import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';
import userUtils from 'utils/User';
import ViewAllLovesBindings from 'analytics/bindingMethods/pages/viewAllLovesBindings/ViewAllLovesBindings';
import { PRODUCT_RECOMMENDATION_ANALYTICS_CATEGORY } from 'ai/constants/superchat';

export function trackAddToBasket(skuId, options = {}) {
    const { useNextPageData = false } = options;

    const data = {
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
        actionInfo: anaConsts.SUPER_CHAT.SUPERCHAT_BASKET,
        eventStrings: 'scAdd',
        productStrings: `;${skuId};;;;eVar26=${skuId}|eVar23=superchat|eVar72=superchat|eVar133=standard`
    };

    if (useNextPageData) {
        anaUtils.setNextPageData(data);
    } else {
        processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data });
    }
}

export function trackAddToLoves(skuId, product = {}) {
    const isAuthenticated = !userUtils.isAnonymous();

    if (isAuthenticated && product) {
        const sku = {
            productId: product.id,
            productName: product.title,
            listPrice: product.list_price,
            brandName: product.brand_name,
            categoryName: '',
            variationType: '',
            variationValue: '',
            isNew: product.isNew,
            isOutOfStock: false
        };
        ViewAllLovesBindings.triggerShareableListSOTAnalytics('love', skuId, sku, []);
    }

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            eventStrings: anaConsts.Event.EVENT_27,
            productStrings: `;${skuId};;;;eVar26=${skuId}`
        }
    });
}

export function trackRemoveFromLoves(skuId, product = {}) {
    const isAuthenticated = !userUtils.isAnonymous();

    if (isAuthenticated && product) {
        const sku = {
            productId: product.id,
            productName: product.title,
            listPrice: product.list_price,
            brandName: product.brand_name,
            categoryName: '',
            variationType: '',
            variationValue: '',
            isNew: product.isNew,
            isOutOfStock: false
        };
        ViewAllLovesBindings.triggerShareableListSOTAnalytics('un-love', skuId, sku, []);
    }

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
            eventStrings: anaConsts.Event.EVENT_28,
            productStrings: `;${skuId};;;;eVar26=${skuId}`
        }
    });
}

export function buildBasketAnalyticsData(sku, options = {}) {
    const { sotV425 = null } = options;

    return {
        productId: sku.productId,
        brandName: sku.brand_name,
        productName: sku.title,
        category: PRODUCT_RECOMMENDATION_ANALYTICS_CATEGORY,
        pageName: anaConsts.SUPER_CHAT.SUPERCHAT_LANDING,
        customActionInfo: anaConsts.SUPER_CHAT.SUPERCHAT_BASKET,
        productStrings: [`;${sku.skuId};;;;eVar26=${sku.skuId}|eVar23=superchat|eVar133=standard`],
        fromSuperChatModal: true,
        ...(sotV425 && { sotV425 })
    };
}
